<template>
  <main class="main" style="background-color: white;">
    <portal to="headerTitle">
      Connect.S ARR
    </portal>
    <template v-if="appId !== null && propertyId !== null && token !== null">
      <card cols="12" title="ARR">
        <hm-card-inner full-size>
          <hm-col cols="12">
            <div id="sushadowdomwrapper" ref="suwidget" style="display: flex;"></div>
          </hm-col>
        </hm-card-inner>
      </card>
    </template>
    <spinner-overlay v-if="showSpinner" />
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil, isEmpty } from 'lodash';
import LoadingWrapper from '../../../lib/util/LoadingWrapper';
import TimerMixin from '../../../../mixins/TimerMixin';
import Card from '../../../lib/layout/Card.vue';
import HmCardInner from '../../../lib/layout/HmCardInner.vue';

export default {
  name: 'PageChannelManagerSuArrV2',
  components: { HmCardInner, Card, LoadingWrapper },
  mixins: [HotelmeisterMixin, TimerMixin],

  data: function () {
    return {
      appId: null,
      propertyId: null,
      token: null,
      showSpinner: true,
      canLoad: false,
      loadingIframe: false,
    };
  },

  computed: {
    suParams: function () {
      return {
        elementId: 'suwidget', // it should be same as abov added div id.
        type: 'arr', // is must be same.
        appId: this.appId, // it’s your pms domain base64 converted value.
        propertyId: this.propertyId, // you have to pass encrypted property id which getting from api which is mention below.
        token: this.token, // you have to pass token id which getting from api which is mention below.
        // channelCode: "", // if user want to pass particular channel code then they need to pass code over here and if user not pass anything then all the channel load by default.
        language: ['ar', 'zn', 'en', 'fr', 'ja', 'ka', 'de', 'it', 'pl', 'es', 'uk'].find(lang => lang === this.$shortLocale) || 'en', // user want to pass language then they need to pass language code over here.
        themeColor: { // user want to  customize your module based on color then passobject over here example object is mention below.
          iconColor: '#aacbee',
        },
      };
    },
  },

  watch: {
    appId: function (newVal) {
      this.updateSpinner();
    },
    propertyId: function (newVal) {
      this.updateSpinner();
    },
    token: function (newVal) {
      this.updateSpinner();
    },
    canLoad: function (newVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          this.$suWidget(this.suParams);
        });
      }
    },
  },


  created: function () {
    this.loadData();
  },

  methods: {
    $suWidget() {
      const elem = this.$refs.suwidget;

      if (isNil(elem)) {
        this.setTimeout(this.$suWidget, 1000);
        return;
      }

      // Create an iframe
      const iframe = document.createElement('iframe');
      iframe.style.width = '100%';
      iframe.style.border = 'none';
      // 100vh - 6rem (header) - 8rem (main padding) - 5rem (card title) - 1rem (just to be safe, we don't get a scrollbar)
      iframe.style.height = 'calc(100vh - 6rem - 8rem - 5rem - 1rem)';
      elem.appendChild(iframe);

      const $vm = this;

      function tryLoadIframe() {
        if ($vm.loadingIframe) return;
        $vm.loadingIframe = true;
        try {
          const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

          // Create a container for the widget within the iframe
          const widgetDiv = iframeDocument.createElement('div');
          widgetDiv.id = 'suwidget';
          iframeDocument.body.appendChild(widgetDiv);

          // Load the external widget script within the iframe
          const externalScript = iframeDocument.createElement('script');
          externalScript.src = 'https://static.otaswitch.com/JS/script.js';
          externalScript.async = true;
          iframeDocument.body.appendChild(externalScript);

          // Wait for the external script to load
          externalScript.onload = () => {
            // Create the inline script to load the widget
            const inlineScript = iframeDocument.createElement('script');
            inlineScript.type = 'application/javascript';
            inlineScript.textContent = `
              const suParams = ${JSON.stringify($vm.suParams)};
              loadSuWidget(suParams);
            `;
            iframeDocument.body.appendChild(inlineScript);
          };
        } catch (e) {
          $vm.loadingIframe = false;
          $vm.$rollbar.error(e);
        }
      }

      // Wait for the iframe to load
      iframe.onload = () => {
        tryLoadIframe();
      };

      this.setTimeout(tryLoadIframe, 2500);

    },
    updateSpinner() {
      if (isEmpty(this.appId) || isEmpty(this.token) || isEmpty(this.propertyId)) {
        this.canLoad = false;
        this.showSpinner = true;
      } else {
        this.canLoad = true;
        this.setTimeout(() => { this.showSpinner = false; }, 2500);
      }
    },
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.channelManagerSu.mappingWidget(this))
        .then((response) => {
          this.appId = response.data.data.app_id;
          this.propertyId = response.data.data.proppmsid;
          this.token = response.data.data.token_id;
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageChannelManagerSuArrV2.vue